<img [src]="sanitizedAvatar" alt="User Avatar" (error)="handleAvatarError($event)" />
